<section class="panel panel--form-narrow" data-testid="restablecer-password" aria-labelledby="restablecer-titulo">
    <h2 id="restablecer-titulo" class="panel__title">Restablecer contraseña</h2>
    @if (!puede) {
        <p class="small mb-0" data-testid="password-sin-permiso"><i class="bi bi-lock-fill me-1" aria-hidden="true"></i>Solo las personas con el permiso «contrasenas:restablecer» pueden restablecer contraseñas.</p>
    } @else {
        <p class="panel__lead">
            Estás restableciendo la contraseña de <strong>{{ nombre }}</strong>. No hace falta conocer la actual: escribe la nueva y confirma la operación.
            Las sesiones abiertas con la anterior dejarán de ser válidas.
        </p>
        <label for="nuevaPassword" class="form-label">Nueva contraseña</label>
        <div class="input-group has-validation">
            <input id="nuevaPassword" class="form-control" [type]="mostrar ? 'text' : 'password'" [formControl]="password" autocomplete="new-password"
                [class.is-invalid]="mostrarError" [readonly]="guardando" data-testid="password-nueva"
                [attr.aria-invalid]="mostrarError" [attr.aria-describedby]="mostrarError ? 'nuevaPassword-error' : 'nuevaPassword-ayuda'"
                (keydown.enter)="solicitar()">
            <button type="button" class="btn btn-outline-secondary" data-testid="password-mostrar" [attr.aria-pressed]="mostrar" (click)="mostrar = !mostrar">{{ mostrar ? 'Ocultar' : 'Mostrar' }}</button>
        </div>
        @if (mostrarError) {
            <div id="nuevaPassword-error" class="field-error" role="alert" data-testid="password-error">{{ error }}</div>
        } @else {
            <div id="nuevaPassword-ayuda" class="form-text">Mínimo 8 caracteres.</div>
        }
        <div class="mt-3">
            <button type="button" class="btn btn-primary" data-testid="password-restablecer" [disabled]="guardando" (click)="solicitar()">{{ guardando ? 'Restableciendo…' : 'Restablecer contraseña' }}</button>
        </div>
    }
</section>
